<script>
    import "./footer.css";
    import {POLYGEN_STATIC_SITE_BASE_URL} from "../../constants/constants";
    let footerLogo = "./images/footer-logo.svg";
    let whiteLogo = "./images/mini-logo.png";
    let twitterIcon = "./images/twitter.svg";
    let linkedinIcon = "./images/linkedin.svg";
    let telegramIcon = "./images/telegram.svg";
    let mediumIcon = "./images/medium.svg";
</script>
<footer class="main-footer flex flex-wrap column-direction">
    <div class="container flex">
        <div class="footer-info flex flex-wrap column-direction flex-text-center items-start">
            <section class="flex items-center column-direction">
                <a href={POLYGEN_STATIC_SITE_BASE_URL} class="footer-logo"><img src={footerLogo} alt="footer logo"></a>
                <a class="mail" href="mailto:info@polygen.io"> info@polygen.io</a>
                <img src={whiteLogo} alt="polygen">
            </section>
        </div>
        <div class="footer-info flex flex-wrap column-direction">
            <h2 class="widget-footer-title">General</h2>
            <ul class="list-none flex flex-wrap">
                <li><a href="https://polygen.io/">Home</a></li>
                <li><a href="https://polygen.io/#our-solution">Our Solution</a></li>
                <li><a href="https://polygen.io/#about">About Us</a></li>
                <li><a href="https://polygen.io/#how-it-works">How it Works</a></li>
                <li><a href="mailto:info@polygen.io">Contact Us</a></li>
                <li><a href="https://polygen.io/#eco-system">Polygen Eco-System</a></li>
                <li><a href="https://polygen.io/#team">Team</a></li>
                <li><a href="https://polygen.io/#road">Roadmap</a></li>
            </ul>
        </div>
        <div class="footer-info flex flex-wrap column-direction social-network">
            <h2 class="widget-footer-title">Social Media</h2>
            <ul class="list-none flex flex-wrap">
                <li><a href="https://twitter.com/Polygen_io" target="_blank"><img src={twitterIcon} alt="social icon">Twitter</a></li>
                <li><a href="https://www.linkedin.com/company/polygen-launchpad" target="_blank"><img src={linkedinIcon} alt="social icon">Linkedin</a></li>
                <li><a href="https://t.me/polygen_launchpad" target="_blank"><img src={telegramIcon} alt="social icon">Telegram</a></li>
                <li><a href="https://medium.com/@polygen" target="_blank"><img src={mediumIcon} alt="social icon">Medium</a></li>
            </ul>
        </div>
    </div>
    <div class="container">
        <div class="copyright">
            <p>Copyright © 2022. Polygen</p>
        </div>
    </div>
</footer>
